const accordionCollapseDurationMs = 350;
const expandedModifierCls = "_mkbe1x275zx";
const wrapperCls = "_mkbwlur4n6";
const headerFocusContainer = "_mkbh5gqq2h";
const header = "_mkbh1rdxi6c";
const toggleBtnCls = "_mkbtp9hx0";
const headingCls = "_mkbh88yfxi";
const chevronCls = "_mkbces4p24";
const contentCls = "_mkbcw72pei";
const contentPaddingCls = "_mkbcwkzuv1";

export { accordionCollapseDurationMs, chevronCls, contentCls, contentPaddingCls, expandedModifierCls, header, headerFocusContainer, headingCls, toggleBtnCls, wrapperCls };
import "./accordion-panel.style.linaria.module.css";
//# sourceMappingURL=accordion-panel.style.js.map
